<template>
  <div class="s-drawer">
    <a-drawer :title="title" :width="750" @close="onClose" :visible="visible">
      <div class="s-drawer-form">
        <a-form :form="form" layout="horizontal">
          <!-- 策略名称 -->
          <a-row>
            <a-col :span="12" v-if="type === 'edit'" style="display:none">
              <a-form-item>
                <a-input v-decorator="['id']" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label="策略名称"
                :label-col="{ span: 7 }"
                :wrapper-col="{ span: 15 }"
              >
                <a-input
                  v-decorator="[
                    'name',
                    {
                      rules: [{ required: true, message: '请输入策略名称' }]
                    }
                  ]"
                  placeholder="请输入策略名称"
                  autocomplete="off"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <!-- 选择优惠餐次 -->
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="优惠餐次"
                :label-col="{ span: 7 }"
                :wrapper-col="{ span: 15 }"
              >
                <a-select
                  mode="multiple"
                  placeholder="请选择优惠餐次"
                  @change="chageDiscountDining"
                  v-decorator="[
                    'discountDining',
                    {
                      rules: [{ required: true, message: '请选择优惠餐次' }]
                    }
                  ]"
                >
                  <a-select-option value="1">
                    早餐
                  </a-select-option>
                  <a-select-option value="2">
                    午餐
                  </a-select-option>
                  <a-select-option value="3">
                    晚餐
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 遍历生成早中晚表单 -->
          <div v-if="discountDiningData.length">
            <div v-for="item in discountDiningData" :key="item.diningType">
              <a-divider>
                {{
                  item.diningType === "1"
                    ? "早餐"
                    : item.diningType === "2"
                    ? "午餐"
                    : item.diningType === "3"
                    ? "晚餐"
                    : ""
                }}
              </a-divider>
              <!-- 优惠类型 -->
              <a-row>
                <a-col :span="12">
                  <a-form-item
                    label="优惠类型"
                    :label-col="{ span: 7 }"
                    :wrapper-col="{ span: 15 }"
                  >
                    <a-select
                      placeholder="请选择优惠类型"
                      @change="chageDiscountType($event, item.diningType)"
                      v-decorator="[
                        `discountType_${item.diningType}`,
                        {
                          rules: [{ required: true, message: '请选择优惠类型' }]
                        }
                      ]"
                    >
                      <a-select-option
                        v-for="diningTypeItem in discountTypes"
                        :value="diningTypeItem.id"
                        :key="diningTypeItem.id"
                      >
                        {{ diningTypeItem.text }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <!-- 优惠金额+实际金额 -->
              <a-row>
                <a-col :span="12">
                  <template
                    v-if="
                      selectDiscountType[Number(item.diningType) - 1] === 0 ||
                        selectDiscountType[Number(item.diningType) - 1] === 1 ||
                        selectDiscountType[Number(item.diningType) - 1] === 3
                    "
                  >
                    <a-form-item
                      label="优惠金额"
                      :label-col="{ span: 7 }"
                      :wrapper-col="{ span: 15 }"
                      :help="discountMoneyHelp[Number(item.diningType) - 1]"
                      :validateStatus="
                        discountMoneyValidateStatus[Number(item.diningType) - 1]
                      "
                    >
                      <a-input
                        placeholder="请输入优惠金额"
                        v-decorator="[
                          `discountMoney_${item.diningType}`,
                          {
                            rules: [
                              { required: true, message: '请输入优惠金额' },
                              {
                                pattern: /(^[0-9](\d+)?(\.?(\d{1,2})?)$)|(^\d\.\d{1,2}$)/,
                                message: '优惠金额格式不正确'
                              },
                              {
                                validator: validatorDiscountMoney
                              }
                            ]
                          }
                        ]"
                        autocomplete="off"
                      >
                        <span slot="prefix" style="color:#999">￥</span>
                      </a-input>
                    </a-form-item>
                  </template>
                  <template
                    v-if="selectDiscountType[Number(item.diningType) - 1] === 2"
                  >
                    <a-form-item
                      label="折扣"
                      :label-col="{ span: 7 }"
                      :wrapper-col="{ span: 15 }"
                    >
                      <a-input
                        placeholder="请输入折扣"
                        v-decorator="[
                          `discountMoney_${item.diningType}`,
                          {
                            rules: [
                              { required: true, message: '请输入折扣' },
                              { validator: validatorDiscount }
                            ]
                          }
                        ]"
                        autocomplete="off"
                      />
                    </a-form-item>
                  </template>
                  <template
                    v-if="selectDiscountType[Number(item.diningType) - 1] === 4"
                  >
                    <a-form-item
                      label="满减"
                      :label-col="{ span: 7 }"
                      :wrapper-col="{ span: 15 }"
                    >
                      <span
                        style="display: inline-block;width: 24px;text-align: center;"
                        >满</span
                      >
                      <a-input
                        :style="{
                          display: 'inline-block',
                          width: 'calc(50% - 24px)'
                        }"
                        v-decorator="[
                          `discountMoney_${item.diningType}`,
                          {
                            rules: [
                              { required: true, message: '请输入满减金额' },
                              {
                                pattern: /(^[0-9](\d+)?(\.?(\d{1,2})?)$)|(^\d\.\d{1,2}$)/,
                                message: '满减金额格式不正确'
                              }
                            ]
                          }
                        ]"
                        autocomplete="off"
                      >
                        <span slot="prefix" style="color:#999">￥</span>
                      </a-input>
                      <span
                        style="display: inline-block;width: 24px;text-align: center;"
                        >减</span
                      >
                      <a-form-item
                        :style="{
                          display: 'inline-block',
                          width: 'calc(50% - 24px)'
                        }"
                      >
                        <a-input
                          v-decorator="[
                            `discountMoney2_${item.diningType}`,
                            {
                              rules: [
                                { required: true, message: '请输入满减金额' },
                                {
                                  pattern: /(^[0-9](\d+)?(\.?(\d{1,2})?)$)|(^\d\.\d{1,2}$)/,
                                  message: '满减金额格式不正确'
                                }
                              ]
                            }
                          ]"
                          autocomplete="off"
                        >
                          <span slot="prefix" style="color:#999">￥</span>
                        </a-input>
                      </a-form-item>
                    </a-form-item>
                  </template>
                </a-col>
                <a-col :span="12">
                  <a-form-item
                    label="实际金额"
                    :label-col="{ span: 7 }"
                    :wrapper-col="{ span: 15 }"
                    :help="actualMoneyHelp[Number(item.diningType) - 1]"
                    :validateStatus="
                      actualMoneyValidateStatus[Number(item.diningType) - 1]
                    "
                  >
                    <a-tooltip
                      placement="top"
                      title="实际金额为0表示结算时按照实际菜品价格计算"
                    >
                      <a-input
                        placeholder="请输入实际金额"
                        v-decorator="[
                          `actualMoney_${item.diningType}`,
                          {
                            rules: [
                              { required: true, message: '请输入实际金额' },
                              {
                                pattern: /(^[0-9](\d+)?(\.?(\d{1,2})?)$)|(^\d\.\d{1,2}$)/,
                                message: '实际金额格式不正确'
                              },
                              {
                                validator: validatorActualMoney
                              }
                            ]
                          }
                        ]"
                        autocomplete="off"
                      >
                        <span slot="prefix" style="color:#999">￥</span>
                      </a-input>
                    </a-tooltip>
                  </a-form-item>
                </a-col>
              </a-row>
              <!-- 扣费策略周期 -->
              <div
                v-for="(cycleItem, cycleIndex) in item.cycleTypeList"
                :key="cycleItem"
              >
                <a-divider :dashed="true"></a-divider>
                <a-row>
                  <a-col :span="12">
                    <a-form-item
                      label="策略周期"
                      :label-col="{ span: 7 }"
                      :wrapper-col="{ span: 15 }"
                    >
                      <a-select
                        @change="
                          changeCycleTypes($event, item.diningType, cycleItem)
                        "
                        placeholder="请选择策略周期"
                        v-decorator="[
                          `cycleType_${item.diningType}_${cycleItem}`,
                          {
                            rules: []
                          }
                        ]"
                      >
                        <a-select-option
                          v-for="cycleDropItem in cycleTypes"
                          :value="cycleDropItem.id"
                          :key="cycleDropItem.id"
                          :disabled="
                            Boolean(
                              item.hasSelectCycles.filter(
                                item => item.value === cycleDropItem.id
                              ).length
                            )
                          "
                        >
                          {{ cycleDropItem.text }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      label="优惠次数"
                      :label-col="{ span: 7 }"
                      :wrapper-col="{ span: 15 }"
                    >
                      <a-input
                        placeholder="请输入优惠次数"
                        v-decorator="[
                          `discountCount_${item.diningType}_${cycleItem}`,
                          {
                            rules: [
                              {
                                pattern: /^[0-9]*[1-9][0-9]*$/,
                                message: '优惠次数格式不正确，请输入正整数'
                              }
                            ]
                          }
                        ]"
                        type="Number"
                        min="1"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="12">
                    <a-form-item
                      label="限制刷卡次数"
                      :label-col="{ span: 7 }"
                      :wrapper-col="{ span: 15 }"
                    >
                      <a-input
                        placeholder="请输入限制刷卡次数"
                        v-decorator="[
                          `limitCount_${item.diningType}_${cycleItem}`,
                          {
                            rules: [
                              {
                                pattern: /^[0-9]*[1-9][0-9]*$/,
                                message: '优惠次数格式不正确，请输入正整数'
                              }
                            ]
                          }
                        ]"
                        type="Number"
                        min="1"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <div class="action-icon-group">
                      <a-tooltip
                        placement="top"
                        title="新增策略周期"
                        v-if="
                          cycleIndex === item.cycleTypeList.length - 1 &&
                            item.cycleTypeList.length < cycleTypes.length
                        "
                      >
                        <span
                          class="add-icon"
                          @click="addCycle(item.diningType)"
                        >
                          <a-icon type="plus-circle" />
                        </span>
                      </a-tooltip>
                      <a-tooltip
                        placement="top"
                        :title="
                          item.cycleTypeList.length !== 1
                            ? '删除这条策略周期'
                            : '清空这条策略周期'
                        "
                      >
                        <span
                          class="del-icon"
                          @click="delCycle(item.diningType, cycleItem)"
                        >
                          <a-icon type="minus-circle" />
                        </span>
                      </a-tooltip>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </div>
          </div>

          <div v-else>
            <a-divider>
              请先选择优惠餐次
            </a-divider>
          </div>
        </a-form>
      </div>
      <div
        :style="{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right'
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="onClose">
          取消
        </a-button>
        <a-button @click="onSubmit" type="primary" :loading="submitLoading"
          >提交</a-button
        >
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { getDiscountType, getCycleType } from '@/apis/strategy';
import { groupBy } from '@/utils/base';

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      title: '添加扣费策略',
      // 优惠餐次
      discountDiningData: [],
      // 类型下拉
      discountTypes: [],
      cycleTypes: [],
      selectDiscountType: [0, 0, 0],
      discountMoneyValidateStatus: ['success', 'success', 'success'],
      actualMoneyValidateStatus: ['success', 'success', 'success'],
      discountMoneyHelp: ['', '', ''],
      actualMoneyHelp: ['', '', '']
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add'
    },
    submitLoading: Boolean,
    detailData: Object,
    submitSuccess: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 校验折扣
    validatorDiscount(rule, value, callback) {
      if (!/(^0\.\d*[1-9]\d*$)/.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('折扣优惠格式不正确，请输入大于0小于1的小数')
      }
      callback()
    },
    // 校验优惠金额，实际金额
    validatorDiscountMoney(rule, value, callback) {
      // eslint-disable-next-line no-unused-vars
      const type = rule.field.split('_')[1]
      const [num1, num2] = [Number(value), Number(this.form.getFieldsValue()[`actualMoney_${type}`])]
      if (num2 !== 0 && num1 > num2) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('优惠金额不能大于实际金额')
        this.discountMoneyValidateStatus[Number(type) - 1] = 'error'
        this.discountMoneyHelp[Number(type) - 1] = '优惠金额不能大于实际金额'
      } else {
        this.discountMoneyValidateStatus[Number(type) - 1] = 'success'
        this.actualMoneyValidateStatus[Number(type) - 1] = 'success'
        this.discountMoneyHelp[Number(type) - 1] = ''
        this.actualMoneyHelp[Number(type) - 1] = ''
      }
      callback()
    },
    validatorActualMoney(rule, value, callback) {
      // eslint-disable-next-line no-unused-vars
      const type = rule.field.split('_')[1]
      const [num1, num2] = [Number(this.form.getFieldsValue()[`discountMoney_${type}`]), Number(value)]
      if (num2 !== 0 && num1 > num2) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('实际金额不能小于优惠金额')
        this.actualMoneyValidateStatus[Number(type) - 1] = 'error'
        this.actualMoneyHelp[Number(type) - 1] = '实际金额不能小于优惠金额'
      } else {
        this.actualMoneyValidateStatus[Number(type) - 1] = 'success'
        this.discountMoneyValidateStatus[Number(type) - 1] = 'success'
        this.actualMoneyHelp[Number(type) - 1] = ''
        this.discountMoneyHelp[Number(type) - 1] = ''
      }
      callback()
    },
    // 更改策略周期
    changeCycleTypes(value, type, cycleItem) {
      const temp = this.discountDiningData.filter(item => item.diningType === type)[0]
      const tempObj = {
        key: cycleItem,
        value: value
      }
      const filterArr = temp.hasSelectCycles.filter(item => item.key === cycleItem)
      if (!filterArr.length) {
        temp.hasSelectCycles.push(tempObj)
      } else {
        filterArr[0].value = value
      }
    },
    // 更改优惠餐次
    chageDiscountDining(value) {
      const temp = value.sort()
      this.discountDiningData = temp.map(item => ({
        diningType: item,
        cycleTypeList: [new Date().getTime()],
        hasSelectCycles: []
      }))
    },
    // 更改优惠类型
    chageDiscountType(value, type) {
      const index = Number(type) - 1
      this.selectDiscountType[index] = value
    },
    // 获取优惠类型
    _getDiscountType() {
      getDiscountType().then(res => {
        this.discountTypes = []
        if (res.data.state === 1) {
          this.discountTypes = res.data.attribute.filter(item => item.id !== 0)
        }
      })
    },
    // 获取周期类型
    _getCycleType() {
      getCycleType().then(res => {
        this.cycleTypes = []
        if (res.data.state === 1) {
          this.cycleTypes = res.data.attribute
        }
      })
    },
    // 新增策略周期
    addCycle(type) {
      const temp = this.discountDiningData.filter(item => item.diningType === type)[0]
      if (temp.cycleTypeList.length < this.cycleTypes.length) {
        temp.cycleTypeList.push(new Date().getTime())
      }
    },
    // 删除策略周期
    delCycle(type, cycleItem) {
      const temp = this.discountDiningData.filter(item => item.diningType === type)[0]
      const formItemName = `cycleType_${type}_${cycleItem}`
      let formValues = this.form.getFieldsValue()
      const formItemValue = formValues[formItemName]

      if (formItemValue !== undefined) {
        const tempIndex = temp.hasSelectCycles.indexOf(formItemValue)
        temp.hasSelectCycles.splice(tempIndex, 1)
      }

      if (temp.cycleTypeList.length === 1) {
        let tempCycleChildObj = {}
        tempCycleChildObj[`cycleType_${type}_${cycleItem}`] = ''
        tempCycleChildObj[`discountCount_${type}_${cycleItem}`] = ''
        tempCycleChildObj[`limitCount_${type}_${cycleItem}`] = ''
        this.form.setFieldsValue(tempCycleChildObj)
      } else {
        if (temp.cycleTypeList.length <= this.cycleTypes.length) {
          const tempIndex = temp.cycleTypeList.indexOf(cycleItem)
          temp.cycleTypeList.splice(tempIndex, 1)
        }
      }
    },
    onSubmit() {
      this.form.validateFields((err, formValues) => {
        if (err) return

        let submitData = {
          Name: formValues.name,
          StrategysList: [{
            PublicMenuType: 1,
            DiscountType: formValues.discountType_1 || 0,
            DiscountValue1: formValues.discountMoney_1,
            ActAmount: formValues.actualMoney_1,
            Diet_StrategyPeriodList: []
          }, {
            PublicMenuType: 2,
            DiscountType: formValues.discountType_2 || 0,
            DiscountValue1: formValues.discountMoney_2,
            ActAmount: formValues.actualMoney_2,
            Diet_StrategyPeriodList: []
          }, {
            PublicMenuType: 3,
            DiscountType: formValues.discountType_3 || 0,
            DiscountValue1: formValues.discountMoney_3,
            ActAmount: formValues.actualMoney_3,
            Diet_StrategyPeriodList: []
          }]
        }
        if (formValues.discountType_1 === 4) {
          submitData.StrategysList[0].DiscountValue2 = formValues.discountMoney2_1
        }
        if (formValues.discountType_2 === 4) {
          submitData.StrategysList[1].DiscountValue2 = formValues.discountMoney2_2
        }
        if (formValues.discountType_3 === 4) {
          submitData.StrategysList[2].DiscountValue2 = formValues.discountMoney2_3
        }
        if (this.type === 'edit') {
          submitData.Id = formValues.id
        }
        let handleArr = []
        for (let key1 in formValues) {
          if (key1.includes('cycleType') || key1.includes('discountCount') || key1.includes('limitCount')) {
            handleArr.push(key1)
          }
        }
        let handleGroupByObj = groupBy(handleArr, (item) => item.split('').reverse().join('').substring(0, 15).split('').reverse().join(''))

        let handleArr1 = []
        for (let key2 in handleGroupByObj) {
          handleArr1.push(key2)
        }
        let handleGroupByObj1 = groupBy(handleArr1, (item) => item.substring(0, 1))

        for (let key3 in handleGroupByObj1) {
          handleGroupByObj1[key3].forEach(item => {
            if (formValues[`cycleType_${item}`] !== undefined && formValues[`discountCount_${item}`] !== undefined && formValues[`limitCount_${item}`] !== undefined) {
              submitData.StrategysList[Number(key3) - 1].Diet_StrategyPeriodList.push({
                PeriodType: formValues[`cycleType_${item}`],
                DisCount: formValues[`discountCount_${item}`],
                LimitCount: formValues[`limitCount_${item}`]
              })
            }
          })
        }

        this.$emit('submit', submitData)
      })
    },
    clearForm() {
      this.discountDiningData = []
      this.form.setFieldsValue({
        id: '',
        name: '',
        discountDining: []
      })
    },
    onClose() {
      this.clearForm()
      this.$emit('close')
    }
  },
  mounted() {
    this._getDiscountType()
    this._getCycleType()
  },
  watch: {
    type(newVal) {
      if (newVal === 'add') {
        this.title = '添加扣费策略'
      } else if (newVal === 'edit') {
        this.title = '修改扣费策略'
      }
    },
    submitSuccess(newVal) {
      if (newVal) {
        this.clearForm()
      }
    },
    detailData(newVal) {
      // this.discountDiningData
      if (!(newVal.strategysList && newVal.strategysList.length)) return
      this.selectDiscountType = newVal.strategysList.map(item => item.discountType)
      for (let i = 0; i < newVal.strategysList.length; i++) {
        let item = newVal.strategysList[i]
        if (item.discountType !== 0) {
          const tempCycleObj = {
            diningType: String(item.publicMenuType),
            cycleTypeList: [],
            hasSelectCycles: []
          }
          if (item.diet_StrategyPeriodList.length) {
            item.diet_StrategyPeriodList.forEach((cItem, cIndex) => {
              let that = this;
              (function (cIndex) {
                setTimeout(() => {
                  const time = new Date().getTime()
                  tempCycleObj.cycleTypeList.push(time)
                  tempCycleObj.hasSelectCycles.push({
                    key: time,
                    value: cItem.periodType
                  })
                  setTimeout(() => {
                    let tempCycleChildObj = {}
                    tempCycleChildObj[`cycleType_${i + 1}_${time}`] = cItem.periodType
                    tempCycleChildObj[`discountCount_${i + 1}_${time}`] = cItem.disCount
                    tempCycleChildObj[`limitCount_${i + 1}_${time}`] = cItem.limitCount

                    that.form.setFieldsValue(tempCycleChildObj)
                  }, 1)
                }, 1)
              })(cIndex)
            })
          } else {
            tempCycleObj.cycleTypeList.push(new Date().getTime())
          }

          this.discountDiningData.push(tempCycleObj)
          setTimeout(() => {
            let tempObj = {}
            tempObj[`discountType_${i + 1}`] = item.discountType
            tempObj[`discountMoney_${i + 1}`] = item.discountValue1
            if (item.discountType === 4) {
              tempObj[`discountMoney2_${i + 1}`] = item.discountValue2
            }
            tempObj[`actualMoney_${i + 1}`] = item.actAmount
            this.form.setFieldsValue(tempObj)
          })
        }
      }

      setTimeout(() => {
        this.form.setFieldsValue({
          id: newVal.id,
          name: newVal.name,
          discountDining: this.discountDiningData.map(item => item.diningType)
        })
      }, 1)
    }
  }
};
</script>

<style lang="less" scoped>
.s-drawer-form /deep/ .ant-divider-horizontal.ant-divider-with-text,
.s-drawer-form /deep/ .ant-divider-horizontal.ant-divider-with-text-left,
.s-drawer-form /deep/ .ant-divider-horizontal.ant-divider-with-text-right {
  margin: 15px 0;
}

.s-drawer-form /deep/ .ant-divider-dashed {
  width: 95%;
  min-width: 80%;
  margin: 10px auto;
}
.s-drawer-form /deep/ .ant-form-item {
  margin-bottom: 10px;
}
.action-icon-group {
  margin-right: 15px;
  .add-icon,
  .del-icon {
    float: right;
    margin-right: 15px;
    line-height: 39px;
    font-size: 22px;
    cursor: pointer;
  }
  .add-icon {
    color: #1890ff;
  }
  .del-icon {
    color: #f50;
  }
}
</style>

<style lang="less">
.ant-drawer-body {
  padding: 5px 12px;
  max-height: calc(100% - 108px);
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>